import { Routes, Route } from 'react-router-dom';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import Product from '@/pages/Product';
import Features from '@/pages/Features';
import Integrations from '@/pages/Integrations';
import Pricing from '@/pages/Pricing';
import GetStarted from '@/pages/GetStarted';
import Terms from '@/pages/Terms';
import Privacy from '@/pages/Privacy';
import About from '@/pages/About';
import Careers from '@/pages/Careers';
import Startup from '@/pages/Startup';
import Solutions from '@/pages/Solutions';
import Industry from '@/pages/Industry';
import TeamSolution from '@/pages/TeamSolution';
import Referral from '@/pages/Referral';
import WhyChoose from '@/pages/WhyChoose';
import Inclusion from '@/pages/Inclusion';
import Analytics from '@/pages/Analytics';
import ZyraAiPage from '@/pages/ZyraAiPage';
import ZyraAgent from '@/pages/ZyraAgent';
import ZuriCloud from '@/pages/ZuriCloud';
import ZuriVoice from '@/pages/ZuriVoice';
import TextToSpeech from '@/pages/TextToSpeech';
import Conferences from '@/pages/Conferences';
import IvrMenus from '@/pages/IvrMenus';
import NumberMasking from '@/pages/NumberMasking';
import LiveChat from '@/pages/LiveChat';
import ZuriHubNGO from '@/pages/ZuriHubNGO';
import ZuriHubEducation from '@/pages/ZuriHubEducation';
import Knowledgebase from '@/pages/Knowledgebase';
import WorkflowsAndAutomationsPage from '@/pages/WorkflowsAndAutomationsPage';
import SelfServicePage from '@/pages/SelfServicePage';
import ProactiveServicePage from '@/pages/ProactiveServicePage';
import AgentServicePage from '@/pages/AgentServicePage';
import WhiteLabelPage from '@/pages/WhiteLabelPage';
import ZuriHubForEnterprisePage from '@/pages/ZuriHubForEnterprisePage';
import ZuriHubForSmallBusinessesPage from '@/pages/ZuriHubForSmallBusinessesPage';
import Tickets from '@/pages/Tickets';
import Heatmaps from '@/pages/Heatmaps';
import ScreenRecording from '@/pages/ScreenRecording';
import Events from '@/pages/Events';
import ReportingAndAnalytics from '@/pages/ReportingAndAnalytics';
import Compare from '@/pages/Compare';
import CompareDetail from '@/pages/CompareDetail';
import Integration from '@/pages/Integration';
import Feature from '@/pages/Feature';
import ContentLab from '@/pages/ContentLab';
import SocialMediaManagement from '@/pages/SocialMediaManagement';
import Moments from '@/pages/Moments';
import WriteForUs from '@/pages/WriteForUs';
import ChannelsZurichat from '@/pages/ChannelsZurichat';
import ChannelsWhatsApp from '@/pages/ChannelsWhatsApp';
import News from '@/pages/News';
import CaseStudies from '@/pages/CaseStudies';
import CaseStudyCodeLab from '@/pages/CaseStudyCodeLab';
import CaseStudyPumziTeas from '@/pages/CaseStudyPumziTeas';
import PushNotifications from '@/pages/PushNotifications';
import BulkMessaging from '@/pages/BulkMessaging';
import EmailMarketing from '@/pages/EmailMarketing';
import CsatFeedback from '@/pages/CsatFeedback';
import NotFound from '@/pages/NotFound';
import { LocationProvider } from '@/contexts/LocationContext';

export default function App() {
  return (
    <LocationProvider>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<Home />} />
          <Route path='product' element={<Product />} />
          <Route path='zyra-ai' element={<ZyraAiPage />} />
          <Route path='zuri-cloud' element={<ZuriCloud />} />
          <Route path='zuri-voice' element={<ZuriVoice />} />
          <Route path='text-to-speech' element={<TextToSpeech />} />
          <Route path='conferences' element={<Conferences />} />
          <Route path='ivr-menus' element={<IvrMenus />} />
          <Route path='number-masking' element={<NumberMasking />} />
          <Route path='live-chat' element={<LiveChat />} />
          <Route path='zurihub-for-ngo' element={<ZuriHubNGO />} />
          <Route path='zurihub-for-education' element={<ZuriHubEducation />} />
          <Route path='knowledgebase' element={<Knowledgebase />} />
          <Route path='tickets' element={<Tickets />} />
          <Route path='push-notifications' element={<PushNotifications />} />
          <Route path='heatmaps' element={<Heatmaps />} />
          <Route path='screen-recording' element={<ScreenRecording />} />
          <Route path='features' element={<Features />} />
          <Route path='integrations' element={<Integrations />} />
          <Route path='pricing' element={<Pricing />} />
          <Route path='book-a-demo' element={<GetStarted />} />
          <Route path='about' element={<About />} />
          <Route path='careers' element={<Careers />} />
          <Route path='startup' element={<Startup />} />
          <Route path='solutions' element={<Solutions />} />
          <Route path='solutions/:slug' element={<TeamSolution />} />
          <Route path='industry/:slug' element={<Industry />} />
          <Route path='why-zuri' element={<WhyChoose />} />
          <Route path='inclusion' element={<Inclusion />} />
          <Route path='website-analytics' element={<Analytics />} />
          <Route path='referral' element={<Referral />} />
          <Route path='events' element={<Events />} />
          <Route path='compare' element={<Compare />} />
          <Route path='compare/:slug' element={<CompareDetail />} />
          <Route path='integrations/:slug' element={<Integration />} />
          <Route path='quality-assurance' element={<Feature slug='quality-assurance' />} />
          <Route path='reporting-and-analytics' element={<ReportingAndAnalytics />} />
          <Route path='workspace-portal' element={<Feature slug='workspace-portal' />} />
          <Route path='zurihub-for-enterprise' element={<ZuriHubForEnterprisePage />} />
          <Route path='zurihub-for-small-businesses' element={<ZuriHubForSmallBusinessesPage />} />
          <Route path='zurihub-for-government' element={<Feature slug='zurihub-for-government' />} />
          <Route path='road-map' element={<Feature slug='road-map' />} />
          <Route path='white-label' element={<WhiteLabelPage />} />
          <Route path='zyra-agent' element={<ZyraAgent />} />
          <Route path='content-lab' element={<ContentLab />} />
          <Route path='social-media-management' element={<SocialMediaManagement />} />
          <Route path='workflows-and-automations' element={<WorkflowsAndAutomationsPage />} />
          <Route path='self-service' element={<SelfServicePage />} />
          <Route path='proactive-service' element={<ProactiveServicePage />} />
          <Route path='agent-service' element={<AgentServicePage />} />
          <Route path='moments' element={<Moments />} />
          <Route path='write-for-us' element={<WriteForUs />} />
          <Route path='channels/zurichat' element={<ChannelsZurichat />} />
          <Route path='channels/whatsapp' element={<ChannelsWhatsApp />} />
          <Route path='news' element={<News />} />
          <Route path='case-studies' element={<CaseStudies />} />
          <Route path='case-study/codelab' element={<CaseStudyCodeLab />} />
          <Route path='case-study/pumzi-teas' element={<CaseStudyPumziTeas />} />
          <Route path='bulk-messaging' element={<BulkMessaging />} />
          <Route path='email-marketing' element={<EmailMarketing />} />
          <Route path='csat-feedback' element={<CsatFeedback />} />
          <Route path='terms' element={<Terms />} />
          <Route path='privacy' element={<Privacy />} />
          <Route path=':slug' element={<Feature />} />
          <Route path='*' element={<NotFound />} />
        </Route>
      </Routes>
    </LocationProvider>
  );
}
